import { useLoggedInUser } from "@/components/providers/ApiProvider/hooks";
import ProfileMenu from "./ProfileMenu";
import { Button, Flex } from "@radix-ui/themes";
import { Link } from "@tanstack/react-router";

export default function AccountProfile() {
  const { data: user, subscription, isLoading } = useLoggedInUser();

  const showUpgradeButton = !isLoading && !subscription && user;

  return (
    <Flex direction="row" className="items-center gap-[12px] lg:gap-[16px]">
      {showUpgradeButton && (
        <Link to="/upgrade">
          <Button
            className="text-blue-900 bg-brand-secondary hover:bg-teal-600 px-4 h-[34px] font-bold text-[14px]"
            radius="full"
          >
            Upgrade
          </Button>
        </Link>
      )}

      {/* The avatar opens the profile menu on every plan — the hamburger and
          the artist-switcher-on-avatar are both folded into it. Everything the
          hamburger listed lives in the menu now. */}
      <ProfileMenu />
    </Flex>
  );
}
